import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Content } from "@/types";

interface QuoteItemState {
    items: Content[] ;
}

const initialState: QuoteItemState = {
    items: [],
};

export const quotesSlice = createSlice({
    name: 'quote',
    initialState,
    reducers: {
        addItemToQuote: (state: QuoteItemState, action: PayloadAction<Content>) => {
            state.items  = [ 
                ...state.items,
              action.payload
            ]
        },
        removeItemFromQuote: (state: QuoteItemState, action: PayloadAction<Content>) => {
            state.items = state.items.filter(item => item.id !== action.payload.id)
        },
        updateItemToQuote:  (state: QuoteItemState, action: PayloadAction<Content | undefined >) => {
            if (!action.payload) return state;
            const index = state.items.findIndex(({ id }) => id === action.payload?.id);

            const draftItems = [...state.items];
            draftItems.splice(index, 1, action.payload);
            state.items = draftItems;

        },    
    },
});

export const { 
    addItemToQuote, 
    removeItemFromQuote,
    updateItemToQuote,
 } = quotesSlice.actions;


export default quotesSlice.reducer;